import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { HashLink } from 'react-router-hash-link';
import API_BASE_URL, { API_IMAGE_BASE_URL } from '../api/config';

// --- SVG Icons for Bottom Nav ---
const HomeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" /></svg>
);
const AboutIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 12h3v8h14v-8h3L12 2zm-2 16h-2v-4h2v4zm4 0h-2v-4h2v4zm4-1.74l-8-6.55-8 6.55V12h16v6.26z" /></svg>
);
const ActivitiesIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>
);
const CampsIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 12h3v8h14v-8h3L12 2zm-2 16h-2v-4h2v4zm4 0h-2v-4h2v4zm4-1.74l-8-6.55-8 6.55V12h16v6.26z" /></svg>
);
const ProfileIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
);

// --- SVG Icons for the new Activities Popup ---
const WorkshopIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" /></svg>
);
const SeminarIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" /></svg>
);
const WebinarIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M21 3H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z" /></svg>
);
const AllActivitiesIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" /></svg>
);

const MobileNavPortal = ({ children }) => {
  // Mounts the children into the document body, escaping any parent transforms
  return ReactDOM.createPortal(children, document.body);
};



const LoginDropdown = () => {
  return (
    <li className="nav-item" style={{ listStyle: "none" }}>
      <NavLink to="/login" className="nav__btn nav__login-btn">
        Login
      </NavLink>
    </li>
  );
};


const Navbar = ({ onTogglePanel }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activitiesPopupOpen, setActivitiesPopupOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [profilePic, setProfilePic] = useState("");

  const [scrolled, setScrolled] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();

  const toggleProfile = () => {
    if (loggedIn && (!userData || userData.noProfile)) {
      navigate('/dashboard/profileEdit');
      return;
    }
    setProfileOpen(prev => !prev);
  };
  const closeProfile = () => {
    setProfileOpen(false);
  };

  const generateDefaultAvatar = (name = "User") => (
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&size=100&background=random&color=fff`
  );

  const actualCookieName = "email";

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".nav-item-profile")) {
        closeProfile();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const userCookie = Cookies.get(actualCookieName);
    if (userCookie) {
      setLoggedIn(true);
      fetchUserProfile(userCookie);
    } else {
      setLoggedIn(false);
      setUserData(null);
      setProfilePic(generateDefaultAvatar());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen || activitiesPopupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen, activitiesPopupOpen]);

  const fetchUserProfile = async (token) => {
    if (!token) {
      setLoggedIn(false);
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/api/profile/read_emails`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include',
      });
      if (response.status === 404) {
        console.warn("Profile not created yet.");
        setUserData({ noProfile: true, email: token }); // Store a placeholder
        return;
      }
      if (!response.ok) {
        throw new Error("Failed to fetch user data");
      }
      const data = await response.json();
      const profile = data.data || data;
      if (profile && profile.email) {
        setUserData(profile);
        const nameParam = profile.full_name ? profile.full_name.trim().replace(/\s+/g, "+") : "User";
        setProfilePic(profile.profile_image ? `${API_IMAGE_BASE_URL}/${profile.profile_image}` : `https://ui-avatars.com/api/?name=${nameParam}&size=100&background=random&color=fff`);
      } else {
        setUserData(null);
        setProfilePic(generateDefaultAvatar());
      }
    } catch (error) {
      console.error("Error in fetchUserProfile:", error);
      setProfilePic(generateDefaultAvatar());
      setUserData(null);
    }
  };

  const handleLogout = () => {
    Cookies.remove(actualCookieName, { path: '/' });
    Cookies.remove("ec_auth_token", { path: '/' });
    setLoggedIn(false);
    setUserData(null);
    setProfilePic(generateDefaultAvatar());
    setMenuOpen(false);
    window.location.href = "/Login";
  };

  const handleProfilePicError = () => {
    setProfilePic(generateDefaultAvatar());
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);
  const toggleActivitiesPopup = () => setActivitiesPopupOpen(!activitiesPopupOpen);
  const closeActivitiesPopup = () => setActivitiesPopupOpen(false);

  // -- Desktop Nav Links ---
  const desktopNavLinks = () => (
    <>
      <li className="nav-item"><NavLink to="/" >Home</NavLink></li>
      <li className="nav-item nav-item-dropdown-wrapper">
        <NavLink to="/about" className="nav-link-dropdown-trigger">
          About
        </NavLink>
        <div className="nav-dropdown-menu">
          <HashLink to="/about#top" className="nav-dropdown-item">About Us</HashLink>
          <HashLink smooth to="/about#Objectives" className="nav-dropdown-item">Our Objectives</HashLink>
          <HashLink smooth to="/about#faq" className="nav-dropdown-item">FAQ</HashLink>
          <HashLink smooth to="/about#gallery" className="nav-dropdown-item">Gallery</HashLink>
        </div>
      </li>
      <li className="nav-item"><NavLink to="/team">Team</NavLink></li>
      <li className="nav-item"><NavLink to="/activities">Activities</NavLink></li>
      <li className="nav-item"><NavLink to="/chapters">Chapters</NavLink></li>
      <li className="nav-item"><NavLink to="/camps">Camps</NavLink></li>
      <li className="nav-item"><NavLink to="/valumni">Valumni</NavLink></li>
    </>
  );

  // --- Profile/Auth Section for the Full-Screen Mobile Menu ---
  const mobileMenuHeader = () => {
    if (loggedIn && userData) {
      return (
        <div className="nav__mobile-profile">
          <img src={profilePic} alt="Profile" className="nav__profile-pic" onError={handleProfilePicError} />
          <h3 className="nav__profile-name">Hi, {userData.full_name || "User"}</h3>
          <p className="nav__profile-email">{userData.email}</p>
          <div className="nav__mobile-actions">
            <NavLink to="/dashboard" className="nav__btn" onClick={closeMenu}>Dashboard</NavLink>
            <NavLink to="/dashboard/profileEdit" className="nav__btn" onClick={closeMenu}>Edit Profile</NavLink>
            <NavLink to="/dashboard/certificates" className="nav__btn" onClick={closeMenu}>Certificates</NavLink>
            <NavLink to="/dashboard/events-booked" className="nav__btn" onClick={closeMenu}>Events Booked</NavLink>
            <button onClick={handleLogout} className="nav__btn nav__btn--logout">Log Out</button>
          </div>
        </div>
      );
    } else if (!loggedIn) {
      return (
        <div className="nav__mobile-profile">
          <LoginDropdown />
        </div>
      );
    } else {
      return null; // Wait for userData to load before showing anything
    }
  };

  const activitiesPopupMenu = () => (
    <div className={`activities-popup ${activitiesPopupOpen ? "open" : ""}`}>
      <div className="activities-popup__overlay" onClick={closeActivitiesPopup}></div>
      <div className="activities-popup__menu">
        <NavLink to="/team" className="activities-popup__item" onClick={closeActivitiesPopup}>
          <WorkshopIcon className="activities-popup__icon" />
          <span>Team</span>
        </NavLink>
        <NavLink to="/chapters" className="activities-popup__item" onClick={closeActivitiesPopup}>
          <WorkshopIcon className="activities-popup__icon" />
          <span>Ethiccraft_Chapters</span>
        </NavLink>
        <NavLink to="/valumni" className="activities-popup__item" onClick={closeActivitiesPopup}>
          <SeminarIcon className="activities-popup__icon" />
          <span>Valumni</span>
        </NavLink>
        <NavLink to="/campus-ambassador" className="activities-popup__item" onClick={closeActivitiesPopup}>
          <WebinarIcon className="activities-popup__icon" />
          <span>Campus Ambassadors</span>
        </NavLink>
        <div className="activities-popup__divider"></div>
        <NavLink to="/activities" className="activities-popup__item" onClick={closeActivitiesPopup}>
          <AllActivitiesIcon className="activities-popup__icon" />
          <span>All Activities</span>
        </NavLink>
      </div>
    </div>
  );

  // --- Render the Navbar ---
  return (
    <>
      {/* --- DESKTOP TOP NAVBAR --- */}
      <nav className={`navbar-desktop ${scrolled ? "navbar--compact" : "navbar--expanded"}`}>
        <div className="navbar__container navbar__container--centered">
          {/* LEFT */}
          <div className="navbar__left">
            <NavLink to="/" className="navbar__logo-link">
              <img src="assets/ethiccraft_full_logo.png" alt="Ethiccraft Logo" className="navbar__logo-img" />
            </NavLink>
          </div>
  
          {/* CENTER */}
          <div className="navbar__center">
            <ul className="nav__links-desktop">
              {desktopNavLinks()}
            </ul>
          </div>
  
          {/* RIGHT */}
          <div className="navbar__right">
            {loggedIn || userData ? (
              <li className="nav-item nav-item-profile" style ={{ listStyle: "none" }}>
                <div className="nav__profile-toggle" onClick={toggleProfile} role="button" aria-expanded={profileOpen}>
                  <img
                    src={profilePic}
                    alt="Profile"
                    className="nav__profile-pic"
                    onError={handleProfilePicError}
                  />
                </div>
                <div className={`nav__profile-dropdown ${profileOpen ? "open" : ""}`}>
                  <div className="nav__dropdown-container">
                    <div className="nav__profile-header">
                      <div className="nav__profile-avatar">
                        {userData?.full_name?.charAt(0) || "U"}
                      </div>
                      <div className="nav__profile-info">
                        <span className="nav__profile-name">{userData?.full_name || "User Account"}</span>
                        <span className="nav__profile-email">{userData?.email || "Personal Workspace"}</span>
                      </div>
                    </div>

                    <div className="nav__dropdown-content">
                      <div className="nav__dropdown-section">
                        <NavLink to="/dashboard" className="nav__dropdown-item">
                          <svg className="nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                          Dashboard
                          {/* <span className="nav__item-badge">New</span> */}
                        </NavLink>
                        {/* <NavLink to="/settings" className="nav__dropdown-item">
                          <svg className="nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
                          Settings
                        </NavLink> */}
                      </div>

                      <div className="nav__dropdown-divider" />

                      <div className="nav__dropdown-section">
                        <button onClick={handleLogout} className="nav__dropdown-item nav__logout">
                          <svg className="nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                          Log out
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ) : (
              <LoginDropdown />
            )}
          </div>
        </div>
      </nav>

      {/* --- MOBILE/TABLET FLOATING BOTTOM NAVBAR --- */}
      <MobileNavPortal>
        <nav className="navbar-mobile">
          <NavLink to="/" className="navbar-mobile__link">
            <HomeIcon className="navbar-mobile__icon" />
            <span>Home</span>
          </NavLink>
          <NavLink to="/about" className="navbar-mobile__link">
            <AboutIcon className="navbar-mobile__icon" />
            <span>About</span>
          </NavLink>
          <button onClick={toggleActivitiesPopup} className="navbar-mobile__link navbar-mobile__button">
            <ActivitiesIcon className="navbar-mobile__icon" />
            <span>More</span>
          </button>
          <NavLink to="/camps" className="navbar-mobile__link">
            <CampsIcon className="navbar-mobile__icon" />
            <span>Camps</span>
          </NavLink>
          <button onClick={() => {
            if (loggedIn && (!userData || userData.noProfile)) {
              navigate('/dashboard/profileEdit');
            } else {
              toggleMenu();
            }
          }} 
            className="navbar-mobile__link navbar-mobile__button">
            <ProfileIcon className="navbar-mobile__icon" />
            <span>Profile</span>
          </button>
        </nav>
      </MobileNavPortal>

      {/* --- RENDER POPUP AND FULLSCREEN MENUS --- */}
      {activitiesPopupMenu()}

      {/* --- FULL SCREEN MENU (Opened by Profile button on mobile) --- */}
      <div className={`nav__menu-fullscreen ${menuOpen ? "open" : ""}`}>
        <div className="nav__menu-fullscreen-header">
          <NavLink to="/" className="navbar__logo-link" onClick={closeMenu}>
            <img src="assets/ethiccraft_full_logo.png" alt="Ethiccraft Logo" className="navbar__logo-img" />
          </NavLink>
          <button
            className={`nav__menu-close-btn ${menuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Close navigation menu"
          >
            <span></span>
            <span></span>
          </button>
        </div>
        <div className="nav__mobile-scrollable">
          {mobileMenuHeader()}
        </div>
      </div>
    </>
  );
};

export default Navbar;